<div class="select-in-table-text-dropdown-menu" data-cy="select-in-table-dropdown-menu" ngbDropdownMenu>
  @if (showDescription) {
    @for (option of dropdownOptions; track option) {
      <button data-cy="select-in-table-dropdown-menu-option"
        (click)="selectOption(option)"
        [attr.disabled]="option?.disabled"
        ngbDropdownItem>
        @if (optionHasTooltip(option)) {
          <app-tooltip [dynamic]="false" [message]="$safeNavigationMigration(option?.tooltip)">
            <div class="button-tooltip-option"></div>
          </app-tooltip>
        }
        <p data-cy="select-in-table-dropdown-menu-option-title" class="title">{{visualCode(option)}}</p>
        <p class="description">{{option.description}}</p>
      </button>
    }
  }
  @if (!showDescription) {
    @for (option of dropdownOptions; track option) {
      <app-tooltip [disable]="optionHasTooltip(option)" [dynamic]="false" [message]="tooltipMessage">
        <button (click)="selectOption(option)" ngbDropdownItem>
          <p class="title">{{visualCode(option)}}</p>
        </button>
        <ng-template #tooltipMessage>
          <ng-container *ngTemplateOutlet="dropdownTooltip; context: option"></ng-container>
        </ng-template>
      </app-tooltip>
    }
  }
</div>
